// extracted by mini-css-extract-plugin
export default {"container":"NahZ9","shareButtons":"_1ZWZl","flexContainer":"_1HLqC","stats":"Xi0_Q","comments":"DlJ6M"};